<template>
  <dashboard-page
    title="Requerimentos"
    subtitle="Lista de requerimentos enviados"
  >
    <template #actions>
      <router-link v-if="addPlaceIssuesRole" :to="{ path: '/issues/add' }">
        <base-button size="sm" type="neutral">Novo</base-button>
      </router-link>
    </template>
    <div class="content">
    <b-container fluid>
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <div>
            <b-col
              cols="12"
              class="d-flex justify-content-center justify-content-sm-between d-flex flex-row bd-highlight mb-3 flex-wrap"
            >
              <div class="col-md-4 col-xs-4">
                <el-select
                  class="select-primary pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-4 col-xs-4">
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Buscar..."
                >
                </base-input>
              </div>
            </b-col>

            <div class="table-container">
              <el-table
                class="ui compact celled definition table"
                :data="queriedData"
                row-key="id"
                header-row-class-name="thead-light"
                @sort-change="sortChange"
                @selection-change="selectionChange"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  v-bind="column"
                >
                </el-table-column>
                <el-table-column
                  v-if="viewPlaceIssuesRole"
                  min-width="100px"
                  align="right"
                  label="Detalhes"
                >
                  <div slot-scope="{ $index, row }" class="d-flex">
                    <router-link
                      :to="{ name: 'Issues Details', params: { issues: row } }"
                    >
                      <base-button class="edit" type="primary" size="sm" icon>
                        <i class="text-white ni ni-bold-down"></i>
                      </base-button>
                    </router-link>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Mostrando {{ from + 1 }} a {{ to }} de {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} linhas selecionadas
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </b-container>
  </div>
  </dashboard-page>
</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components'
import clientPaginationMixin from './../Tables/PaginatedTables/clientPaginationMixin'
import { mapGetters } from 'vuex'
import bocapioService from './../../services/nodejs/index'
import { forEach } from 'jszip'
import { map } from 'd3'
import Card from '../../components/Cards/Card.vue'
import Vue from 'vue'
import TranslucentTableVue from '../Tables/RegularTables/TranslucentTable.vue'

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    Card,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      viewPlaceIssuesRole: null,
      addPlaceIssuesRole: null,
      tableColumns: [
        /**
        {
          type: "selection"
        },
         *
         */
        {
          prop: 'user.name',
          label: 'Requerente',
          minWidth: 160,
          sortable: true,
          movil: true,
        },
        {
          prop: 'date',
          label: 'Data',
          minWidth: 190,
          formatter: (row, col, cell, index) =>
            this.formatDataLocaleString(cell),
          sortable: true,
          movil: true,
        },
        {
          prop: 'issues_type.label',
          label: 'Tipo',
          minWidth: 150,
          sortable: true,
          movil: true,
        },
        {
          prop: 'issues_status.status',
          label: 'Status',
          minWidth: 140,
          sortable: true,
          movil: true,
        },
      ],
      tableData: [],
      selectedRows: [],
      tableUser: [],
    }
  },
  mounted() {
    this.roles.issues ? this.getUserRoles() : ''
    this.findAllByUserRules()
    console.log(
      'roles',
      this.roles,
      this.viewPlaceIssuesRole,
      this.addPlaceIssuesRole
    )
    // this.detectarMobile();
  },
  methods: {
    findAllByUserRules() {
      bocapioService
        .findAllByUserRules()
        .then((rsp) => {
          rsp.data ? (this.tableData = rsp.data) : (this.tableData = [])
          //this.fillCards(this.tableData)
          this.createFuseSearch([
            'user.name',
            'issues_type.label',
            'date',
            'issues_status.status',
          ])
        })
        .catch((error) => {
          console.log('resposta findAllByUserRules ', error)
        })
    },

    paginationChanged(page) {
      this.pagination.currentPage = page
    },

    handleEdit(index, row) {
      this.$router.push({
        name: 'Issues Details',
        params: { issues: row }, // data[1] is id in table
      })
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },

    getUserRoles() {
      //TODO: Verificar se o usuário tem permissão para ver os detalhes dos requerimentos
      this.roles['issues'].forEach((role) => {
        console.log('role', role.action)
      })

      this.viewPlaceIssuesRole = this.roles.issues.find(
        (role) => role.controller === 'issues' && role.action === 'details'
      )
      this.addPlaceIssuesRole = this.roles.issues.find(
        (role) =>
          role.controller === 'issues' && role.action === 'add_place_issues'
      )
    },
  },
  computed: {
    ...mapGetters('auth', {
      roles: 'getRules',
    }),
  },
  modules: [
    'semantic-ui-vue/nuxt', // includes styles from semantic-ui-css
    ['semantic-ui-vue/nuxt', { css: TranslucentTableVue }], // if you have your own semantic-ui styles
  ],
}
</script>
<style>
@import url('//unpkg.com/element-ui@2.0.8/lib/theme-chalk/index.css');
.no-border-card .card-footer {
  border-top: 0;
}
</style>
